<div class="container-fluid page-content">
    <!-- <div class="col-sm-12" style="text-align: center;">  <span>List Supplier</span> <br /></div> -->

<p style="color: green;" >Thank you for your order! Your request is currently under review for approval. You will receive an email notification once it has been approved, and we will proceed with delivery accordingly.</p>
<p>You order number is : <b>{{orderNumber}}</b></p>
<p> <button mat-raised-button color="primary" (click)="view()">Shop More</button></p>
<div *ngIf="fromExcel">
    Download Order details with Succes/Error message
<button  mat-raised-button color="accent" (click)="download()">Download</button>
</div>
</div>  